export default {
  FETCH_EVENT_SUBSCRIPTIONS_FROM_ADMIN: 'FETCH_EVENT_SUBSCRIPTIONS_FROM_ADMIN',
  SAVE_EVENT_SUBSCRIPTION_FROM_ADMIN: 'SAVE_EVENT_SUBSCRIPTION_FROM_ADMIN',
  DELETE_EVENT_SUBSCRIPTION_FROM_ADMIN: 'DELETE_EVENT_SUBSCRIPTION_FROM_ADMIN',
  FETCH_EVENT_SUBSCRIPTIONS_FROM_ADMIN_SUCCESS: 'FETCH_EVENT_SUBSCRIPTIONS_FROM_ADMIN_SUCCESS',
  ENABLE_EVENT_SUBSCRIPTION_FROM_ADMIN: 'ENABLE_EVENT_SUBSCRIPTION_FROM_ADMIN',
  DISABLE_EVENT_SUBSCRIPTION_FROM_ADMIN: 'DISABLE_EVENT_SUBSCRIPTION_FROM_ADMIN'
}
